import React from 'react';
import { MdNotifications } from 'react-icons/md';

function Features() {
  return (
    <div>
      <div className='flex flex-col space-y-5'>
        <h1 className='text-4xl font-bold text-center'>Features</h1>
        <div className='flex flex-row justify-start items-center space-x-5'>
          <MdNotifications className='text-3xl bg-red-900 rounded-full text-white p-2' />
          <div>
            <h2 className='text-xl font-bold'>Notifications</h2>
            <p>
              Increase engagement in your matches by creating real-time
              notifications to your club members to keep them up to date with
              the scoreline or notable events.
            </p>
          </div>
        </div>

        <div className='flex flex-row justify-start items-center space-x-5'>
          <MdNotifications className='text-3xl bg-red-900 rounded-full text-white p-2' />
          <div>
            <h2 className='text-xl font-bold'>My Club</h2>
            <p>
              A central space for all club members to find out about upcoming
              matches, training sessions and other important club updates.
            </p>
          </div>
        </div>
      </div>
      <h2 className='text-lg font-semi-bold mt-20 text-center'>
        New and exciting features are currently in development. Watch this
        space!
      </h2>
    </div>
  );
}

export default Features;
